import Vue from "vue";
import App from "@/views/App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import vuetify from "./plugins/vuetify";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import VueGtag from "vue-gtag";
import i18n from "@/i18n";

import { firebaseConfig } from "@/firebase/firestore";

Vue.config.productionTip = false;
Vue.use(VueGtag, {
  config: { id: firebaseConfig.measurementId }
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount("#app");
